import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDockResize } from 'site-modules/canvas/hooks/use-dock-resize';
import { CANVAS_ICONS } from 'site-modules/canvas/constants/canvas';
import { BlobWrapper } from 'site-modules/canvas/components/blob-wrapper/blob-wrapper';

import './docked-panel.scss';

export function DockedPanel({
  children,
  iframeRef,
  className = null,
  resizeContainerClassname = null,
  trackingParent = null,
  fullWidth = false,
}) {
  const { containerRef, resizeRef, onResizeStart } = useDockResize(iframeRef);

  return (
    <div
      ref={containerRef}
      className={classnames('docked-panel', { 'full-width': fullWidth }, className)}
      data-tracking-parent={trackingParent}
    >
      <div
        ref={resizeRef}
        className={classnames(
          'resize-container pos-a top-0 left-0 h-100 d-flex flex-column pb-1 pt-2',
          resizeContainerClassname,
          {
            'px-1': fullWidth,
            'ps-1 pe-1_5': !fullWidth,
          }
        )}
      >
        <BlobWrapper />
        {children}
        {!fullWidth && (
          <div
            aria-hidden
            className="resizer pos-a top-0 right-0 h-100 bg-cool-gray-70"
            title="Drag to resize"
            onMouseDown={onResizeStart}
          >
            <div className="handle pos-a center-xy rounded bg-cool-gray-90">
              <img className="pos-a center-xy" src={CANVAS_ICONS.DOTS} alt="" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

DockedPanel.propTypes = {
  children: PropTypes.func.isRequired,
  iframeRef: PropTypes.shape({ current: PropTypes.shape() }).isRequired,
  className: PropTypes.string,
  resizeContainerClassname: PropTypes.string,
  trackingParent: PropTypes.string,
  fullWidth: PropTypes.bool,
};
